/**
 * The homepage's blocks in their page order, by id. `HomeV4Client` renders
 * the ones not parked, in this order, unless it gets another one through its
 * `order` prop (ids left out of the list are hidden).
 *
 * The order is the one Eugene set on 23.09. "Parked"
 * blocks are off the page but still built, so they can come back: one plan,
 * your rhythm and stories.
 */
export const HOME_V4_BLOCKS = [
  { id: "hero", label: "Hero + trust strip" },
  { id: "fullView", label: "A full view of your health" },
  { id: "familiar", label: "Sound familiar?" },
  { id: "whyNow", label: "Today is a good day to start" },
  { id: "onePlan", label: "Everything lands in one plan", parked: true },
  { id: "whatYouGet", label: "What you get" },
  { id: "doctors", label: "Who creates your plan" },
  { id: "compare", label: "Compared with a standard check-up" },
  { id: "baseline", label: "Start with your baseline" },
  { id: "insurance", label: "Supplementary insurance" },
  { id: "practical", label: "Your rhythm", parked: true },
  { id: "stories", label: "Stories", parked: true },
  { id: "reviews", label: "Real results from real people" },
  { id: "faq", label: "FAQ" },
  { id: "close", label: "Not sure where to start?" },
] as const satisfies readonly { id: string; label: string; parked?: true }[]

export type HomeV4BlockId = (typeof HOME_V4_BLOCKS)[number]["id"]

/** The page as built: every block that is not parked. */
export const HOME_V4_BLOCK_IDS: readonly HomeV4BlockId[] =
  HOME_V4_BLOCKS.filter((b) => !("parked" in b)).map((b) => b.id)
